import { render, staticRenderFns } from "./FormSolution.vue?vue&type=template&id=82094eb4&"
import script from "./FormSolution.vue?vue&type=script&lang=js&"
export * from "./FormSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports